import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { getProfile, resetProfile, authMe, authLogout } from "./api";

const SparkCtx = createContext(null);

export const SparkProvider = ({ children }) => {
  const [userId, setUserId] = useState(() => localStorage.getItem("spark_user") || "sarah");
  const [profile, setProfile] = useState(null);
  const [session, setSession] = useState(undefined); // undefined = checking, null = none, object = signed-in pilot
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async (uid = userId) => {
    setLoading(true);
    try {
      setProfile(await getProfile(uid));
    } catch {
      setProfile(null);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    const check = (attempt = 0) => authMe()
      .then(u => { setSession(u); setUserId(u.user_id); })
      .catch(e => {
        if (e?.response?.status !== 401 && attempt < 2) return setTimeout(() => check(attempt + 1), 1500);
        setSession(s => (s === undefined ? null : s));
      });
    check();
  }, []);

  useEffect(() => {
    if (session === undefined) return;
    if (!session) {
      if (localStorage.getItem("spark_dev") !== "1") { setLoading(false); return; }
      localStorage.setItem("spark_user", userId);
    }
    refresh(userId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, session]);

  const switchUser = (uid) => setUserId(uid);
  const startFresh = async () => { await resetProfile("fresh"); setUserId("fresh"); };
  const switchToSarah = () => setUserId("sarah");
  const signOut = async () => { await authLogout(); setSession(null); setProfile(null); setUserId("fresh"); };
  const isPilot = !!session;
  const isDev = !isPilot && localStorage.getItem("spark_dev") === "1";

  return (
    <SparkCtx.Provider value={{ userId, profile, loading, session, isPilot, isDev, refresh, switchUser, startFresh, switchToSarah, setProfile, signOut, setSession }}>
      {children}
    </SparkCtx.Provider>
  );
};

export const useSpark = () => useContext(SparkCtx);
